'use client'

export default function InnerLayout({ children }) {
  return (
    <div className="flex flex-col justify-between min-h-[100vh]">
      <div className="flex-1">{children}</div>
    </div>
  )
}
